import React, { Component, Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Loadable from 'react-loadable';
import '../../node_modules/font-awesome/scss/font-awesome.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import Loader from './layout/Loader';
import Aux from "../hoc/_Aux";
import ScrollToTop from './layout/ScrollToTop';
import NoSidebarLayout from './layout/NoSidebarLayout';

// Import private routes
import AdminPrivateRoute from "../AdminPrivateRoute";
import CustomerPrivateRoute from "../CustomerPrivateRoute";

// ---------------- LOADABLE COMPONENTS ----------------
const AdminLayout = Loadable({
    loader: () => import('./layout/AdminLayout'),
    loading: Loader
});

const FrontPage = Loadable({
    loader: () => import('../Demo/FrontPage/frontPage'),
    loading: Loader
});

const AdminSignIn = Loadable({
    loader: () => import('../Demo/Authentication/SignIn/SignIn1'),
    loading: Loader
});


const CustomerSignIn = Loadable({
    loader: () => import('../Demo/Authentication/CustomerSignIn/Customer'),
    loading: Loader
});

const CustomerSignUp = Loadable({
    loader: () => import('../Demo/Authentication/CustomerSignIn/CustomerSignUp'),
    loading: Loader
});

const VerifyEmail = Loadable({
    loader: () => import('../Demo/Authentication/CustomerSignIn/VerifyEmail'),
    loading: Loader
});

const Customer = Loadable({
    loader: () => import('../Demo/Customer'),
    loading: Loader
});

const Orderside = Loadable({
    loader: () => import('../Demo/Orderside/OrdersideBar'),
    loading: Loader
});

const Quotes = Loadable({
    loader: () => import('../Demo/quotes/quotes'),
    loading: Loader
});

const CustomerDetail = Loadable({
    loader: () => import('../Demo/Details/Detail'),
    loading: Loader
});

const ThreeDViewDetail = Loadable({
    loader: () => import('../Demo/ThreeDviewDetails/ThreeDViewDetail'),
    loading: Loader
});

// Admin pages
const DashboardDefault = Loadable({
    loader: () => import('../Demo/Dashboard/Default'),
    loading: Loader
});

const Dashboarddemo = Loadable({
    loader: () => import('../Demo/Dashboarddemo/dashboarddemo'),
    loading: Loader
});

const PrintTech = Loadable({
    loader: () => import('../Demo/PrintTech/Print'),
    loading: Loader
});

const Estimate = Loadable({
    loader: () => import('../Demo/Estimate/estimate'),
    loading: Loader
});

const Invoice = Loadable({
    loader: () => import('../Demo/invoice/invoice'),
    loading: Loader
});

const Salesorder = Loadable({
    loader: () => import('../Demo/Salesorder/salesorder'),
    loading: Loader
});

const Pendquo = Loadable({
    loader: () => import('../Demo/pendingquote/pendquo'),
    loading: Loader
});

const Quotecustomer = Loadable({
    loader: () => import('../Demo/Custquo/custquo'),
    loading: Loader
});


// ---------------- MAIN APP COMPONENT ----------------
class App extends Component {
    render() {
        return (
            <Aux>
                <ScrollToTop>
                    <Suspense fallback={<Loader />}>
                        <Switch>
                            {/* ----------- PUBLIC ROUTES ----------- */}
                            <Route path="/frontpage" component={FrontPage} />
                            <Route
                                path="/auth/signin-customer"
                                render={(props) => (
                                    <NoSidebarLayout>
                                        <CustomerSignIn {...props} />
                                    </NoSidebarLayout>
                                )}
                            />
                            <Route
                                path="/auth/signup-customer"
                                render={(props) => (
                                    <NoSidebarLayout>
                                        <CustomerSignUp {...props} />
                                    </NoSidebarLayout>
                                )}
                            />
                            <Route
                                path="/verify-email"
                                render={(props) => (
                                    <NoSidebarLayout>
                                        <VerifyEmail {...props} />
                                    </NoSidebarLayout>
                                )}
                            />
                            <Route
                               path ="/auth/signin-1"
                               render={(props)=>(
                                <NoSidebarLayout>
                                    <AdminSignIn {...props} />
                                </NoSidebarLayout>
                               )}
                               />

                            {/* ----------- CUSTOMER PROTECTED ROUTES ----------- */}
                            <CustomerPrivateRoute path="/customer" component={Customer} />
                            <CustomerPrivateRoute path="/orderside" component={Orderside} />
                            <CustomerPrivateRoute path="/quotes" component={Quotes} />
                            <CustomerPrivateRoute path="/detail" component={CustomerDetail} />
                            <CustomerPrivateRoute path="/threeDviewdetails" component={ThreeDViewDetail} />

                                                       {/* ----------- ADMIN PROTECTED ROUTES WITH SIDEBAR ----------- */}
                            <AdminPrivateRoute
                                path="/dashboard/default"
                                component={(props) => (
                                    <AdminLayout>
                                        <DashboardDefault {...props} />
                                    </AdminLayout>
                                )}
                            />
                            <AdminPrivateRoute
                                path="/dashboarddemo"
                                component={(props) => (
                                    <AdminLayout>
                                        <Dashboarddemo {...props} />
                                    </AdminLayout>
                                )}
                            />
                            <AdminPrivateRoute
                                path="/print"
                                component={(props) => (
                                    <AdminLayout>
                                        <PrintTech {...props} />
                                    </AdminLayout>
                                )}
                            />
                            <AdminPrivateRoute
                                path="/custquo"
                                component={(props) => (
                                    <AdminLayout>
                                        <Quotecustomer {...props} />
                                    </AdminLayout>
                                )}
                            />
                            <AdminPrivateRoute
                                path="/estimate"
                                component={(props) => (
                                    <AdminLayout>
                                        <Estimate {...props} />
                                    </AdminLayout>
                                )}
                            />
                            <AdminPrivateRoute
                                path="/invoice"
                                component={(props) => (
                                    <AdminLayout>
                                        <Invoice {...props} />
                                    </AdminLayout>
                                )}
                            />
                            <AdminPrivateRoute
                                path="/salesorder"
                                component={(props) => (
                                    <AdminLayout>
                                        <Salesorder {...props} />
                                    </AdminLayout>
                                )}
                            />
                            <AdminPrivateRoute
                                path="/pendquo"
                                component={(props) => (
                                    <AdminLayout>
                                        <Pendquo {...props} />
                                    </AdminLayout>
                                )}
                            />

                            {/* ----------- DEFAULT ROUTE ----------- */}
                            <Redirect exact from="/" to="/auth/signin-customer" />
                            <Route path="/" component={AdminLayout} />
                        </Switch>
                    </Suspense>
                </ScrollToTop>
            </Aux>
        );
    }
}

export default App;
